import type { Profile } from 'models';
import { isGroupAdmin } from '../user-roles';
import { isSuperAdmin } from '../utils';

export const canCreateAnnouncements = ({ groupId, viewer }: { groupId: string; viewer: Profile }) =>
  isSuperAdmin({ viewer }) || isGroupAdmin({ groupId, viewer });
